import request from './request'

export default {
  list(data) {
    return request.post('/videoServer/list', data)
  },
  info(data) {
    return request.post('/videoServer/info', data)
  },
  save(data) {
    return request.post('/videoServer/save', data)
  },
  enable(data) {
    return request.post('/videoServer/enable', data)
  },
  disable(data) {
    return request.post('/videoServer/disable', data)
  },
  delete(data) {
    return request.post('/videoServer/delete', data)
  },
}
